module.exports = __webpack_public_path__ + "img/apidays-ppt-3.4ed786d4.png";